import { useGetList } from "ra-core";
import { ReferenceField } from "@/components/admin/reference-field";
import type { Contact, ZoomMeetingParticipant } from "../types";

// Attendee list for a meeting (by meeting_ref), with a link to the matched contact.
export function MeetingParticipants({ meetingRef }: { meetingRef: number }) {
  const { data: participants, isPending } = useGetList<ZoomMeetingParticipant>(
    "zoom_meeting_participants",
    {
      filter: { meeting_ref: meetingRef },
      pagination: { page: 1, perPage: 200 },
      sort: { field: "duration", order: "DESC" },
    },
  );

  if (isPending) return null;
  if (!participants?.length) {
    return (
      <p className="text-sm text-muted-foreground">No participants recorded.</p>
    );
  }

  return (
    <ul className="divide-y text-sm">
      {participants.map((p) => (
        <li key={p.id} className="flex items-center gap-2 py-1.5">
          <span className="font-medium">
            {p.name ?? p.user_email ?? "Unknown"}
          </span>
          {p.user_email && (
            <span className="text-muted-foreground text-xs">
              {p.user_email}
            </span>
          )}
          {p.contact_id != null && (
            <ReferenceField<ZoomMeetingParticipant, Contact>
              source="contact_id"
              reference="contacts"
              record={p}
              link="show"
              className="ml-auto text-xs text-primary"
              render={({ referenceRecord }) =>
                referenceRecord ? (
                  <span>
                    {referenceRecord.first_name} {referenceRecord.last_name}
                  </span>
                ) : null
              }
            />
          )}
        </li>
      ))}
    </ul>
  );
}
